import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const NotifiedIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8 1C8.65232 1 9.26816 1.15615 9.8122 1.4331C8.73184 2.02892 8 3.17899 8 4.5C8 6.433 9.567 8 11.5 8C11.6698 8 11.8367 7.98791 12 7.96456V8.03028L13.6838 9.60844C13.8856 9.7975 14 10.0616 14 10.3381V11C14 11.5523 13.5523 12 13 12H3C2.44772 12 2 11.5523 2 11V10.3381C2 10.0616 2.11445 9.7975 2.31616 9.60844L4 8.03028V5C4 2.79086 5.79086 1 8 1Z"
		></path>
		<path
			fill="currentColor"
			d="M10 13C10 14.1046 9.10457 15 8 15C6.94564 15 6.08183 14.1841 6.00549 13.1493L6 13H10Z"
		></path>
		<path
			fill="currentColor"
			d="M11.5 7C12.8807 7 14 5.88071 14 4.5C14 3.11929 12.8807 2 11.5 2C10.1193 2 9 3.11929 9 4.5C9 5.88071 10.1193 7 11.5 7Z"
		></path>
	</svg>
))
